
export * from './cars-details-wrapper';
